var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.varComp,{tag:"component",attrs:{"hover":_vm.hovering,"variant":"","resource":_vm.resource,"webpage":_vm.webpage}})}
var staticRenderFns = []

export { render, staticRenderFns }